// (level_points/10000)*250 = credits
// (100000/10000)*250 = 2500
export default [
  {
    level: 1,
    image: 1,
    min: 1000,
    max: 2499,
    credits: 50,
    name: 'Bronze',
    tier: null,
    hidden: false,
  },
  {
    level: 2,
    image: 2,
    min: 2500,
    max: 4999,
    credits: 100,
    name: 'Silver',
    tier: null,
    hidden: false,
  },
  {
    level: 3,
    image: 3,
    min: 5000,
    max: 7499,
    credits: 150,
    name: 'Gold',
    tier: null,
    hidden: false,
  },
  {
    level: 4,
    image: 4,
    min: 7500,
    max: 9999,
    credits: 200,
    name: 'Platinum',
    tier: null,
    hidden: false,
  },
  {
    level: 5,
    image: 5,
    min: 10000,
    max: 12499,
    credits: 250,
    name: 'Emerald',
    tier: null,
    hidden: false,
  },
  {
    level: 6,
    image: 6,
    min: 12500,
    max: 14999,
    credits: 300,
    name: 'Sapphire',
    tier: null,
    hidden: false,
  },
  {
    level: 7,
    image: 7,
    min: 15000,
    max: 19999,
    credits: 400,
    name: 'Ruby',
    tier: null,
    hidden: false,
  },
  {
    level: 8,
    image: 8,
    min: 20000,
    max: 29999,
    credits: 500,
    name: 'Diamond',
    tier: null,
    hidden: false,
  },
  {
    level: 9,
    image: 9,
    min: 30000,
    max: 39999,
    credits: 700,
    name: 'Double Diamond',
    tier: null,
    hidden: false,
  },
  {
    level: 10,
    image: 10,
    min: 40000,
    max: 49999,
    credits: 1000,
    name: 'Triple Diamond',
    tier: null,
    hidden: false,
  },
  {
    level: 11,
    image: 11,
    min: 50000,
    max: 59999,
    credits: 1250,
    name: 'Crown',
    tier: null,
    hidden: false,
  },
  {
    level: 12,
    image: 12,
    min: 60000,
    max: 69999,
    credits: 1500,
    name: 'Excalibur',
    tier: null,
    hidden: false,
  },
  {
    level: 13,
    image: 13,
    min: 70000,
    max: 79999,
    credits: 1750,
    name: 'Double Swords',
    tier: null,
    hidden: false,
  },
  {
    level: 14,
    image: 14,
    min: 80000,
    max: 89999,
    credits: 2000,
    name: 'Jeweled Crown',
    tier: null,
    hidden: false,
  },
  {
    level: 15,
    image: 15,
    min: 90000,
    max: 99999,
    credits: 2250,
    name: 'Shielded Crown',
    tier: null,
    hidden: false,
  },
  {
    level: 16,
    image: 16,
    min: 100000,
    max: 124999,
    credits: 2600,
    name: 'Hall of Fame Crown',
    tier: null,
    hidden: false,
  },
  {
    level: 17,
    image: 17,
    min: 125000,
    max: 149999,
    credits: 3000,
    name: 'Royal Robe',
    tier: null,
    hidden: false,
  },
  {
    level: 18,
    image: 18,
    min: 150000,
    max: 174999,
    credits: 3500,
    name: 'Royal Horse',
    tier: null,
    hidden: false,
  },
  {
    level: 19,
    image: 19,
    min: 175000,
    max: 199999,
    credits: 4000,
    name: 'Royal Carriage',
    tier: null,
    hidden: false,
  },
  {
    level: 20,
    image: 20,
    min: 200000,
    max: 224999,
    credits: 4500,
    name: 'Royal Castle',
    tier: null,
    hidden: false,
  },
  {
    level: 21,
    image: 21,
    min: 225000,
    max: 249999,
    credits: 5000,
    name: 'Royal Army',
    tier: null,
    hidden: false,
  },
  {
    level: 22,
    image: 22,
    min: 250000,
    max: 274999,
    credits: 5000,
    name: 'Dragon',
    tier: null,
    hidden: false,
  },
  {
    level: 23,
    image: 23,
    min: 275000,
    max: 299999,
    credits: 5000,
    name: 'Double Dragons',
    tier: null,
    hidden: false,
  },
  {
    level: 24,
    image: 24,
    min: 300000,
    max: 324999,
    credits: 5000,
    name: 'Iron Throne',
    tier: null,
    hidden: false,
  },
  {
    level: 25,
    image: 24,
    min: 325000,
    max: 349999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 1,
    hidden: true,
  },
  {
    level: 26,
    image: 24,
    min: 350000,
    max: 374999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 2,
    hidden: true,
  },
  {
    level: 27,
    image: 24,
    min: 375000,
    max: 399999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 3,
    hidden: true,
  },
  {
    level: 28,
    image: 24,
    min: 400000,
    max: 424999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 4,
    hidden: true,
  },
  {
    level: 29,
    image: 24,
    min: 425000,
    max: 449999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 5,
    hidden: true,
  },
  {
    level: 30,
    image: 24,
    min: 450000,
    max: 474999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 6,
    hidden: true,
  },
  {
    level: 31,
    image: 24,
    min: 475000,
    max: 499999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 7,
    hidden: true,
  },
  {
    level: 32,
    image: 24,
    min: 500000,
    max: 524999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 8,
    hidden: true,
  },
  {
    level: 34,
    image: 24,
    min: 525000,
    max: 549999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 9,
    hidden: true,
  },
  {
    level: 35,
    image: 24,
    min: 550000,
    max: 574999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 10,
    hidden: true,
  },
  {
    level: 36,
    image: 24,
    min: 575000,
    max: 599999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 11,
    hidden: true,
  },
  {
    level: 37,
    image: 24,
    min: 600000,
    max: 624999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 12,
    hidden: true,
  },
  {
    level: 38,
    image: 24,
    min: 625000,
    max: 649999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 13,
    hidden: true,
  },
  {
    level: 39,
    image: 24,
    min: 650000,
    max: 674999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 14,
    hidden: true,
  },
  {
    level: 40,
    image: 24,
    min: 675000,
    max: 699999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 15,
    hidden: true,
  },
  {
    level: 41,
    image: 24,
    min: 700000,
    max: 724999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 16,
    hidden: true,
  },
  {
    level: 42,
    image: 24,
    min: 725000,
    max: 749999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 17,
    hidden: true,
  },
  {
    level: 43,
    image: 24,
    min: 750000,
    max: 774999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 18,
    hidden: true,
  },
  {
    level: 44,
    image: 24,
    min: 775000,
    max: 799999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 19,
    hidden: true,
  },
  {
    level: 45,
    image: 24,
    min: 800000,
    max: 824999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 20,
    hidden: true,
  },
  {
    level: 46,
    image: 24,
    min: 825000,
    max: 849999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 21,
    hidden: true,
  },
  {
    level: 47,
    image: 24,
    min: 850000,
    max: 874999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 22,
    hidden: true,
  },
  {
    level: 48,
    image: 24,
    min: 875000,
    max: 899999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 23,
    hidden: true,
  },
  {
    level: 49,
    image: 24,
    min: 900000,
    max: 924999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 24,
    hidden: true,
  },
  {
    level: 50,
    image: 24,
    min: 925000,
    max: 949999,
    credits: 5000,
    name: 'Iron Throne',
    tier: 25,
    hidden: true,
  },
]
